import React from 'react';
import { Button, Form, Input, message, Select } from 'antd';
import editDailyCoachingStyles from './EditDailyCoaching.module.css';
import { useUserStore } from '../../../../../context/UserStore';
import { formatDate, formatTime } from '../../../../../utils/dateFormat';

const { useState } = React;

// Rendered by ViewMentor, which does the fetching and picks the form by mentor_type_id.
export default function EditDailyCoaching({ employee, mentor, onSaved }) {
    const [saving, setSaving] = useState(false);
    const { TextArea } = Input;
    const user = useUserStore((state) => state.user);
    const { employee_id: employeeId } = mentor.attributes;

    const onFinish = (values) => {
        updateMentor({
            "mentor": {
                feedback_type: values.feedback_type,
                feedback_text: values.feedback_text
            }
        });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const updateMentor = async (values) => {
        setSaving(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/v1/users/employees/${employeeId}/mentors/${mentor.id}`, {
                method: "put",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${user.token}`,
                },
                body: JSON.stringify(values),
                type: "json"
            });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            if (data.success === false) {
                message.error(data.errors || 'This conversation could not be saved.');
                return;
            }
            message.success('Feedback successfully updated');
            if (onSaved) {
                onSaved();
            }
        } catch (error) {
            console.log(error);
            message.error('This conversation could not be saved.');
        } finally {
            setSaving(false);
        }
    }

    return (
        <>
            <div className={`py-5 grid grid-cols-1 mb-5 ${editDailyCoachingStyles.headerBar}`}>
                <h1 className='text-4xl text-center text-white'>Add or Edit Coaching</h1>
            </div>
            <div className='flex flex-col justify-left'>
                <h1 className='text-xl'>
                    <strong>Name:</strong> {employee.attributes.first_name} {employee.attributes.last_name}
                </h1>
                <p className='text-lg'><strong>Email:</strong> {employee.attributes.email}</p>
            </div>
            <div className='flex flex-col justify-left'>
                <h1 className='text-xl'><strong>Date:</strong> {formatDate(mentor.attributes.occurred_at)} </h1>
                <p className='text-lg'><strong>Time:</strong> {formatTime(mentor.attributes.occurred_at)} </p>
            </div>
            <div className='grid grid-cols-6 gap-4'>
                <div className='col-span-6'>
                    <Form
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        layout="verticle"
                        className='w-full'
                        initialValues={{
                            feedback_type: mentor.attributes.feedback_type,
                            feedback_text: mentor.attributes.feedback_text,
                            file: ''
                        }}
                    >
                        <div className="shadow sm:rounded-md sm:overflow-hidden">
                            <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-12 sm:col-span-2">
                                        <Form.Item
                                            label="Feedback Type"
                                            name="feedback_type"
                                            className='col-span-6 sm:col-span-2'
                                            rules={[{ required: true, message: 'Please select feedback type!' }]}
                                        >
                                            <Select
                                                options={[
                                                    {
                                                        value: 'positive',
                                                        label: 'Positive Feedback',
                                                    },
                                                    {
                                                        value: 'negative',
                                                        label: 'Contructive Criticism',
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-12 sm:col-span-2">
                                        <Form.Item
                                            label="Comments"
                                            name="feedback_text"
                                            className='col-span-6 sm:col-span-2'
                                            rules={[{ required: true, message: 'Please enter comments!' }]}
                                        >
                                            <TextArea rows={4} placeholder='Enter comments here' />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-12 sm:col-span-2">
                                        <Form.Item
                                            label="Upload File"
                                            name="file"
                                            className='col-span-6 sm:col-span-2'
                                        >
                                            <Input type="file" />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-12 sm:col-span-2">
                                        <Form.Item
                                            wrapperCol={{
                                                offset: 8,
                                                span: 16,
                                            }}
                                        >
                                            <Button
                                                className='bg-blue-500 hover:bg-blue-700 text-white font-bold px-4 rounded'
                                                htmlType="submit"
                                                loading={saving}
                                            >
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}
